// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"199d99e8","239":"c3c45917","453":"f90961b2","455":"9c15e347"}[chunkId] + ".chunk.js";
};